<template>
  <table
    ref="#out-table"
    class="print-container_out "
    style="border-collapse:collapse;"
    border="1"
  >
    <thead>
      <tr>
        <th
          v-for="(item) in columns_computed"
          :key="item.key"
        >
          <span>
            {{ item.title }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(list_obj,index) in list_c"
        :key="index"
      >
        <td
          v-for="(citem,itemIndex) in columns_computed"
          :key="itemIndex"
        >
          <div>
            <DownloadTableTd 
              :item="list_obj"
              :item-key="citem.key"
            />
          </div>
        </td>
      </tr> 
    </tbody>
  </table>
</template>
<script>
  import DownloadTableTd from './DownloadTableTd'
  import * as XLSX from 'xlsx'
  import FileSaver from 'file-saver'
  import { getsafe } from '../../../libs/util'
  export default {
    components: {
      DownloadTableTd,
    },
    props: {
      dateArr: {
        type: Array,
      },
      list: {
        type: Array,
      },
      persons: {
        type: Array
      }
    },
    computed: {
      persons_hash() {
        return this.persons.reduce((total, item) => {
          total[item.id] = item
          return total        
        }, {})
      },
      list_c() {    
        const arr = []
        const list = this.list || []
        list.forEach(item => {
      
          const current = {
            name: item.account
          }
          item.salary_list.forEach(i => {
            
            const day_list = getsafe(i, 'detail.day_list', []) || []
            day_list.forEach(j => {
              if (!current[j.day]) {
                current[j.day] = []
              }
              current[j.day].push(j)
            })
          })
          arr.push(current)
        })
        // console.log(arr, 'arr')
        return arr
      },
      columns_computed() {
        /* --------------------------- 打卡日期作为 key 的 hash------------------------------- */
        const list = [{
          title:'姓名',
          key: 'name',
          width: 100,
        }]
        let current = this.dateArr[0]
        const end = this.dateArr[1]
        if (!current || !end) {
          return []
        }
        /* ----------------------- 将数据按一周为一个单位来聚合 ----------------------- */
        while (moment(current).isBefore(end) || current === end) {
          const mmdd = moment(current).format('MM-DD').split('-')
          list.push({
            title:  `${mmdd[0]}月${mmdd[1]}日`,
            key: current,
            width:260,
            // render(h, params) {
            //   // console.log('params', params.column.key)
            //   const current = params.row && params.row[params.column.key]
            //   let { day = '', is_at_office, wage_percent, bonus, tip } = current || {}
            //   day = day || ''
            //   is_at_office = is_at_office || false
            //   wage_percent = wage_percent || 0
             
            //   tip = tip || '-'
            //   const arr = [
            //     {
            //       title:'是否在办公室',
            //       value: is_at_office ? '是' : '否'
            //     },
            //     {
            //       title:'工作时长',
            //       value: `${wage_percent}天`
            //     },
            //     {
            //       title:'奖金',
            //       value: bonus
            //     },
            //     {
            //       title:'备注',
            //       value: tip
            //     }
            //   ]
         
            //   return h('div', {}, arr.map(item => {
            //     return h('p', {}, [item.title, item.value])
            //   }))
            // }
          })
          current = moment(current).add(1, 'day').format('YYYY-MM-DD')
        }
        return list
      }
    },
    methods: {
      outputExcel() { // 导出excel
        /* generate workbook object from table */
   
         
        const wb = XLSX.utils.table_to_book(this.$refs['#out-table'])
        //  console.log('wb', wb.Sheets.Sheet1['!cols'])
        wb.Sheets.Sheet1['!cols'] = new Array(this.columns_computed && this.columns_computed.length).fill({
          wch: 50,
          // wrapText: true
          // wpx:50
        })
       
        Object.keys(wb.Sheets.Sheet1).forEach(key => {
          const target = wb.Sheets.Sheet1[key]
          if (target instanceof Object && !key.includes('!')) {
            target.s = {
              'alignment': {
                'wrapText':true
              }
            }
          }
        })
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${this.dateArr[0]}-${this.dateArr[1]}实习生考勤.xlsx`)
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      },
    }
  }
</script>
